import { ChipTheme } from '@medly-components/theme';

import colors from './colors';

export const chip: ChipTheme = {
    defaultColor: colors.coral[500],
    disabledColor: colors.grey[400]
};
